/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { popupClientControllerFindAllV1 } from '../fn/popup-client/popup-client-controller-find-all-v-1';
import { PopupClientControllerFindAllV1$Params } from '../fn/popup-client/popup-client-controller-find-all-v-1';
import { popupClientControllerFindByIdV1 } from '../fn/popup-client/popup-client-controller-find-by-id-v-1';
import { PopupClientControllerFindByIdV1$Params } from '../fn/popup-client/popup-client-controller-find-by-id-v-1';
import { PopupDto } from '../models/popup-dto';

@Injectable({ providedIn: 'root' })
export class PopupClientService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `popupClientControllerFindAllV1()` */
  static readonly PopupClientControllerFindAllV1Path = '/api/v1/popups/client';

  /**
   * 노출된 팝업 목록 조회 (클라이언트).
   *
   * 노출된 팝업을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupClientControllerFindAllV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupClientControllerFindAllV1$Response(params?: PopupClientControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PopupDto>>> {
    const obs = popupClientControllerFindAllV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 노출된 팝업 목록 조회 (클라이언트).
   *
   * 노출된 팝업을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupClientControllerFindAllV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupClientControllerFindAllV1(params?: PopupClientControllerFindAllV1$Params, context?: HttpContext): Observable<Array<PopupDto>> {
    const resp = this.popupClientControllerFindAllV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<PopupDto>>): Array<PopupDto> => r.body)
    );
  }

  /** Path part for operation `popupClientControllerFindByIdV1()` */
  static readonly PopupClientControllerFindByIdV1Path = '/api/v1/popups/client/{id}';

  /**
   * 팝업 ID 기반 조회 (클라이언트).
   *
   * 팝업을 ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `popupClientControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupClientControllerFindByIdV1$Response(params: PopupClientControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PopupDto>> {
    const obs = popupClientControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 팝업 ID 기반 조회 (클라이언트).
   *
   * 팝업을 ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `popupClientControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  popupClientControllerFindByIdV1(params: PopupClientControllerFindByIdV1$Params, context?: HttpContext): Observable<PopupDto> {
    const resp = this.popupClientControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PopupDto>): PopupDto => r.body)
    );
  }

}
